// Reuse Dawn's native details/summary pattern and Escape handler.
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  function update() {
    document.querySelectorAll('.footer-block--menu').forEach((block) => {
      let details = block.querySelector('.footer-menu-disclosure');
      if (mobile.matches && !details) {
        const heading = block.querySelector('.footer-block__heading');
        const links = block.querySelector('ul');
        if (!heading || !links) return;
        details = document.createElement('details');
        details.className = 'footer-menu-disclosure';
        const summary = document.createElement('summary');
        summary.append(heading);
        details.append(summary, links);
        block.append(details);
        details.addEventListener('keyup', (event) => {
          onKeyUpEscape(event);
          // Native summary exposes its expanded state without redundant ARIA.
          summary.removeAttribute('aria-expanded');
        });
      } else if (!mobile.matches && details) {
        const heading = details.querySelector('.footer-block__heading');
        const links = details.querySelector('ul');
        const hadFocus = details.contains(document.activeElement);
        block.append(heading, links);
        details.remove();
        if (hadFocus) links.querySelector('a')?.focus();
      }
    });
  }
  mobile.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);
  update();
})();
